import type { AffineThemeKeyV2 } from '@streamlain/theme/v2';

import type { Color } from './color';
import { getColorByKey } from './utils';

/** Tag colours by their stored name, as the tone of a frame or note surface. */
const TAG_TONES: Record<string, string> = {
  blue: 'blue',
  gray: 'grey',
  green: 'green',
  orange: 'orange',
  pink: 'magenta',
  purple: 'purple',
  red: 'red',
  teal: 'teal',
  white: 'white',
  yellow: 'yellow',
};

const TAG_VAR = /^--(?:affine|streamlain)-tag-([a-z]+)$/;

export type ColorSurface = 'frame' | 'note';

/**
 * The colour a frame or note background is shown in. Templates store tag
 * colours there (`--affine-tag-purple`); a tag colour is the strong colour of
 * a chip, so a surface shows the light surface colour of the same tone
 * instead. The stored value stays as it is; every other colour passes through.
 */
export function surfaceColor(color: Color, surface: ColorSurface): Color {
  if (typeof color !== 'string') return color;
  const tone = TAG_TONES[TAG_VAR.exec(color)?.[1] ?? ''];
  if (!tone) return color;
  return getColorByKey(
    (surface === 'frame'
      ? `edgeless/frame/background/${tone}`
      : `edgeless/note/${tone}`) as AffineThemeKeyV2
  );
}
